var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2313 1.73125C23.5188 1.01875 22.5625 0.625 21.5688 0.625H4.375C2.3125 0.625 0.64375 2.3125 0.64375 4.375L0.625 30.625C0.625 32.6875 2.29375 34.375 4.35625 34.375H30.625C32.6875 34.375 34.375 32.6875 34.375 30.625V13.4312C34.375 12.4375 33.9813 11.4812 33.2687 10.7875L24.2313 1.73125ZM10 26.875C8.96875 26.875 8.125 26.0312 8.125 25C8.125 23.9688 8.96875 23.125 10 23.125C11.0312 23.125 11.875 23.9688 11.875 25C11.875 26.0312 11.0312 26.875 10 26.875ZM10 19.375C8.96875 19.375 8.125 18.5312 8.125 17.5C8.125 16.4688 8.96875 15.625 10 15.625C11.0312 15.625 11.875 16.4688 11.875 17.5C11.875 18.5312 11.0312 19.375 10 19.375ZM10 11.875C8.96875 11.875 8.125 11.0312 8.125 10C8.125 8.96875 8.96875 8.125 10 8.125C11.0312 8.125 11.875 8.96875 11.875 10C11.875 11.0312 11.0312 11.875 10 11.875ZM21.25 11.875V3.4375L31.5625 13.75H23.125C22.0938 13.75 21.25 12.9062 21.25 11.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCenter);
export default __webpack_public_path__ + "static/media/report_center.c288af7bef8698e4467e79a45e604382.svg";
export { ForwardRef as ReactComponent };